type Props = {
    /**
     * Direction of the skeleton loader animation
     * @default 'horizontal'
     */
    direction?: 'horizontal' | 'vertical'
}

/**
 *
 * @returns A Skeleton loader component that shows a placeholder of the component that will be rendered.
 *
 */
export const AstraSkeletonLoader = ({ direction = 'horizontal' }: Props) => {
    const directionStyling =
        direction === 'vertical'
            ? 'bg-gradient-to-t animate-pulse-fast-vertical bg-[length:100%_200%]'
            : 'bg-gradient-to-l animate-shimmer bg-[length:200%_100%]'

    return <div className={`box-border h-full w-full rounded-lg ${directionStyling} from-[#f0f2ff] via-slate-50 to-[#ECF2FF]`} />
}
